module.exports = __webpack_public_path__ + "img/title.33c358b3.png";